let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Za1J")).then(() => parcelRequire('9U5fj'));